import { render, staticRenderFns } from "./tendero.vue?vue&type=template&id=53301c76&scoped=true&"
import script from "./tendero.vue?vue&type=script&lang=js&"
export * from "./tendero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53301c76",
  null
  
)

export default component.exports